// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XzfM","label":"styles_label__2gF_c"};